<img src="assets/img/logo_big.svg" alt="Logo der Österreichischen Apothekerkammer"/>
<p>{{"LOGOUT.MESSAGE" | translate}}</p>
<app-button (click)="login()" label="{{'LOGOUT.BUTTON' | translate}}"></app-button>

